export { createSitecoreAdapter } from './adapter';
